<!--<div id="error-429" class="flex-column-center-center">-->

<!--<div class="content" class="flex-column-center-center">-->

<!--<div class="error-code">429</div>-->

<!--<div class="message">Too many request...</div>-->

<!--&lt;!&ndash;<div class="search" class="flex-row-start-center">&ndash;&gt;-->
<!--&lt;!&ndash;<mat-icon class="icon s-24">search</mat-icon>&ndash;&gt;-->
<!--&lt;!&ndash;<input placeholder="Search for anything" >&ndash;&gt;-->
<!--&lt;!&ndash;</div>&ndash;&gt;-->

<!--<a class="back-link mt-8" (click)="onPageBack()">Go back to the previous page</a>-->

<!--</div>-->

<!--</div>-->

<div id="error-429" class="flex-column-center-center">
  <div class="content mb-24 mt-32 flex-column-center-center">
    <div class="error-code">429</div>

    <!--<div class="message">{{ 'ERROR_500.MESSAGE' | translate }}</div>-->

    <div class="sub-message">
      {{ "ERROR_429.SUB_MESSAGE" | translate }}
      <!--{{ 'ERROR_429.SUB_MESSAGE' | translate }} <div *ngIf="last429URL"> {{last429URL}}</div>-->
    </div>

    <a class="report-link" (click)="onPageBack()">{{
      "ERROR_429.BACK_PAGE" | translate
    }}</a>
    <a class="report-link" [routerLink]="'/' + appRoutesService.dashboard">{{
      "ERROR_429.BACK_HOME_PAGE" | translate
    }}</a>
    <a class="report-link" (click)="onVisitGt2()">{{
      "ERROR_429.GT2_SITE" | translate
    }}</a>
  </div>

  <!--<div class="content mb-24" class="flex-column-center-center">-->
  <!--<div class="sub-message">-->
  <!--{{ 'ERROR_500.SUB_MESSAGE' | translate }}-->
  <!--</div>-->

  <!--&lt;!&ndash;<a class="back-link mt-8" (click)="onPageBack()">{{ 'ERROR_500.BACK_PAGE' | translate }}</a>&ndash;&gt;-->
  <!--<a class="report-link" (click)="onPageBack()">{{ 'ERROR_500.BACK_PAGE' | translate }}</a>-->
  <!--&lt;!&ndash;<a class="report-link" [routerLink]="'/tableau-de-bord'">{{ 'ERROR_500.REPORT_PROBLEM' | translate }}</a>&ndash;&gt;-->
  <!--</div>-->

  <div class="content-form mb-32 flex-column-center-center">
    <mat-card class="content-form-card" style="width: 100%">
      <mat-card-header
        style="margin-left: 16px !important; margin-top: 8px !important"
      >
        <mat-card-title class="title-card">{{
          "ERROR_429.CONTACT_US" | translate
        }}</mat-card-title>
        <mat-card-subtitle *ngIf="translate.currentLang === 'fr-CA'"
          >Demande de ticket :
          <a href="https://gestiontraiteur.com/demande-de-ticket/"
            >https://gestiontraiteur.com/demande-de-ticket/</a
          >
        </mat-card-subtitle>
        <mat-card-subtitle *ngIf="translate.currentLang === 'en-CA'"
          >Ticket request:
          <a href="https://gestiontraiteur.com/demande-de-ticket/"
            >https://gestiontraiteur.com/demande-de-ticket/</a
          >
        </mat-card-subtitle>
      </mat-card-header>

      <mat-card-content>
        <div [formGroup]="form" class="p-16 flex-column">
          <!--<div class="">Subject</div>-->
          <mat-card-subtitle class="mt-12">{{
            "ERROR_429.CONTACT_MESSAGE" | translate
          }}</mat-card-subtitle>
          <mat-form-field class="" appearance="outline">
            <mat-label>{{ "ERROR_429.SUBJECT" | translate }}</mat-label>
            <input
              matInput
              class="contact-input"
              formControlName="subject"
              type="text"
              [(ngModel)]="subject"
              required
            />
            <mat-error *ngIf="form.controls['subject'].invalid"
              >{{ "GENERIC.INPUT_LENGTH_INVALID" | translate }}
            </mat-error>
          </mat-form-field>

          <!--<div class="mt-4">Message</div>-->
          <mat-form-field class="" appearance="outline">
            <mat-label>Message</mat-label>
            <textarea
              matInput
              class="contact-input"
              rows="6"
              formControlName="message"
              type="text"
              [(ngModel)]="message"
              required
            >
            </textarea>
            <mat-error *ngIf="form.controls['message'].invalid"
              >{{ "GENERIC.INPUT_LONG_LENGTH_INVALID" | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="mr-20 flex-row-end-start">
          <button
            mat-raised-button
            color="accent"
            class=""
            [disabled]="!form.valid"
            (click)="onSendContactForm()"
          >
            {{ "GENERIC.SEND" | translate }}
          </button>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>
